'use client';

export default function IconCopy(props: any) {
    return (
        <>
            <svg {...props} width="1em" height="1em" viewBox="0 0 13 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="会员体系" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="已登陆" transform="translate(-403.000000, -2770.000000)" fill="#BBBBBB" fillRule="nonzero">
                        <g id="-mockplus-" transform="translate(269.000000, 2561.000000)">
                            <g id="-mockplus-" transform="translate(20.000000, 206.500000)">
                                <g id="复制-(1)" transform="translate(114.000000, 3.000000)">
                                    <path
                                        d="M9.09227985,3 L0.904704463,3 C0.404101321,3 0,3.41673734 0,3.93299406 L0,13.0670059 C0,13.5832627 0.404101321,14 0.904704463,14 L9.09529554,14 C9.59589868,14 10,13.5832627 10,13.0670059 L10,3.93299406 C9.99833839,3.41721301 9.5924245,3 9.09227985,3 Z M8.79071171,12.7560079 L1.20627262,12.7560079 L1.20627262,4.24399207 L8.79372738,4.24399207 L8.79372738,12.7560079 L8.79071171,12.7560079 Z"
                                        id="形状"
                                    ></path>
                                    <path
                                        d="M11.2711964,0 L2.64992616,0 C2.29246678,0 2,0.290635092 2,0.645855753 C2,1.00107641 2.29246676,1.29171151 2.64992616,1.29171151 L11.2711964,1.29171151 C11.5084195,1.29171151 11.7001477,1.48223895 11.7001477,1.71797631 L11.7001477,11.3541442 C11.7001477,11.7093649 11.9926145,12 12.3500739,12 C12.7075333,12 13,11.7093649 13,11.3541442 L13,1.71797631 C12.9967504,0.768568341 12.2233383,0 11.2711964,0 Z"
                                        id="路径"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </>
    );
}
